module.exports = __webpack_public_path__ + "assets/static/png/money-red.52fd60209ae8ef85f22fea1f97563ba9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/money-red.png
 ** module id = 510
 ** module chunks = 1
 **/